import { NavLink } from 'react-router-dom';
import styled from '@emotion/styled';
import { Theme } from '@mui/material';

export const Link = styled(NavLink)<{ theme?: Theme }>`
	color: inherit;
	font-size: inherit;
	text-decoration: none;
`;
